import { RenderAirCardProps } from "entities/shared/airCard.types";
import { ShipmentType } from "entities/shared/shipmentCard.types";
import { ValueOf } from "shared/lib/typeCheck.lib";

import { AirSavedCardModel } from "../model/model";

type UsePrepareCardUpdateActionsReturnType = {
  updateCard: (model: AirSavedCardModel) => void;
  shouldUpdateCard: () => boolean;
  isResolvingUpdatePossibility: boolean;
  isCardUpdateSuccess: boolean;
  isCardUpdating: boolean;
};

type AirSavedCardProps = {
  data: AirSavedCardModel;
  openCard: (data: AirSavedCardModel) => void;
  isSavedCardDeleting: boolean;
  useSavedCardUpdateActions: () => UsePrepareCardUpdateActionsReturnType;
  deleteCardHandler: (card: AirSavedCardModel) => void;
  shipmentType: ValueOf<typeof ShipmentType>;
  renderCard: (props: RenderAirCardProps) => JSX.Element;
  className?: string;
};

export const AirSavedCard: RFC<AirSavedCardProps> = ({
  data,
  className,
  openCard,
  isSavedCardDeleting,
  useSavedCardUpdateActions,
  deleteCardHandler,
  shipmentType,
  renderCard,
}) => {
  const { updateCard, shouldUpdateCard, isResolvingUpdatePossibility, isCardUpdating } = useSavedCardUpdateActions();

  const onDeleteHandler = () => {
    if (isSavedCardDeleting || isCardUpdating) return;
    deleteCardHandler(data);
  };

  const onOpenHandler = () => {
    if (isSavedCardDeleting || isCardUpdating) return;
    openCard(data);
  };

  const onUpdateHandler = () => {
    if (isSavedCardDeleting || isCardUpdating) return;
    updateCard(data);
  };

  return renderCard({
    shipmentType,
    className,
    ata: data.ata,
    atd: data.atd,
    eta: data.eta,
    etd: data.etd,
    reference: data.reference,
    status: data.status,
    directionFrom: data.directionFrom,
    directionTo: data.directionTo,
    progressLine: { status: "location-data", percent: data.progress, rotation: "horizontal" },
    onOpen: onOpenHandler,
    onDelete: onDeleteHandler,
    onUpdate: onUpdateHandler,
    canUpdate: shouldUpdateCard(),
    isUpdating: isResolvingUpdatePossibility,
    isDeleteProcessing: isSavedCardDeleting,
    pieces: data.pieces,
    scac: data.carrierScac,
    carrierName: data.carrierName,
    tags: data.tags,
  });
};
